import { render, staticRenderFns } from "./navList.vue?vue&type=template&id=e4b1a238&scoped=true"
import script from "./navList.vue?vue&type=script&lang=js"
export * from "./navList.vue?vue&type=script&lang=js"
import style0 from "./navList.vue?vue&type=style&index=0&id=e4b1a238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b1a238",
  null
  
)

export default component.exports